import { ProcessingAppListItem, ProcessingLineType } from "@api/tryall/ProcessingApplicationApi";
import { ProcessingApplicationState } from "@redux/ProcessingApplicationSlice";
import { Col, Row, Space } from "antd";
import React, { useMemo } from "react";
import { TabContentWrapper } from "src/styles/common";
import styled from "styled-components";
import { useSelector } from "react-redux";
import ProcessAppAddModal from "./ProcessAppAddModal";
import processingStatusOptions, { processingPurposeOptions } from "./ProcessingStatus";

const NoWrapCol = styled(Col)`
  min-width: 120px;
`;

type Props = {
  details: ProcessingAppListItem;
  showEditModal: boolean;
  onModalClose: () => void;
};
const ProcessingApplicationInfo = (props: Props) => {
  const { details, showEditModal, onModalClose } = props;
  const { purpose, procNumber, staff, estDeliveryDate, note, status, createdAt } = details;
  const { processingLineList } = useSelector(ProcessingApplicationState);
  const {
    [ProcessingLineType.TARGET]: processingLineTargetList,
    [ProcessingLineType.SOURCE]: processingLineSourceList,
  } = processingLineList;

  const processingStatus = useMemo(() => {
    return processingStatusOptions.find((item) => item.value === status)?.name || "no match status";
  }, [status]);
  const canEditPurpose = processingLineTargetList.length === 0 && processingLineSourceList.length === 0;

  return (
    <TabContentWrapper>
      {showEditModal && (
        <ProcessAppAddModal onClose={onModalClose} editData={details} canEditPurpose={canEditPurpose} />
      )}
      <Space direction="vertical" size={16}>
        <Row gutter={[0, 16]} wrap={false}>
          <NoWrapCol span={4}>加工單編號</NoWrapCol>
          <Col>{procNumber}</Col>
        </Row>
        <Row gutter={[0, 16]} wrap={false}>
          <NoWrapCol span={4}>建立人員</NoWrapCol>
          <Col>{staff?.name}</Col>
        </Row>
        <Row gutter={[0, 16]} wrap={false}>
          <NoWrapCol span={4}>加工緣由</NoWrapCol>
          <Col>{processingPurposeOptions.find((item) => item.value === purpose)?.label}</Col>
        </Row>
        <Row gutter={[0, 16]} wrap={false}>
          <NoWrapCol span={4}>預計完工日期</NoWrapCol>
          <Col>{estDeliveryDate}</Col>
        </Row>
        <Row gutter={[0, 16]} wrap={false}>
          <NoWrapCol span={4}>備註</NoWrapCol>
          <Col>{note}</Col>
        </Row>
        <Row gutter={[0, 16]} wrap={false}>
          <NoWrapCol span={4}>狀態</NoWrapCol>
          <Col>{processingStatus}</Col>
        </Row>
        <Row gutter={[0, 16]} wrap={false}>
          <NoWrapCol span={4}>建立日期</NoWrapCol>
          <Col>{createdAt}</Col>
        </Row>
      </Space>
    </TabContentWrapper>
  );
};
export default ProcessingApplicationInfo;
